// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageCropperPopup__overlay-ad7108 {
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ImageCropperPopup/ImageCropperPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF","sourcesContent":[".overlay {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `ImageCropperPopup__overlay-ad7108`
};
module.exports = ___CSS_LOADER_EXPORT___;
